import React, { Fragment} from "react";
import { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import SpeedDial from "@material-ui/lab/SpeedDial";
import SpeedDialIcon from "@material-ui/lab/SpeedDialIcon";
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from "@material-ui/core/Grid";

import DirectionsCarIcon from "@material-ui/icons/DirectionsCar";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

// import useApi from "hooks/useApi";
import api from "services/api";

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: 20,
    },
    km: {
        verticalAlign: "top",
    },
    speedDial: {
        position: "fixed",
        bottom: theme.spacing(2),
        right: theme.spacing(2),
    },
    speedDialStart: {
        position: "fixed",
        bottom: theme.spacing(2),
        right: theme.spacing(10),
    },
    spinner: {
        marginTop: 15,
    },
}));

const convertDate = (dateString) => {
  const tmpd = new Date(dateString);
  const d = new Date(tmpd.getTime() + tmpd.getTimezoneOffset() * 60000)
  const dateStr =
      ("0" + d.getDate()).slice(-2) +
      "." +
      ("0" + (d.getMonth() + 1)).slice(-2) +
      "." +
      d.getFullYear() +
      " " +
      ("0" + d.getHours()).slice(-2) +
      ":" +
      ("0" + d.getMinutes()).slice(-2);
  return dateStr;
}



const ListItems = (props) => {
    const classes = useStyles();
    const [state, setState] = useState({ data: null, lastRunning: false, isLoading: false, error: null})
    // const [{data, isLoading}, ] = useApi.get("/api/rides/list");

    useEffect(() => {
        const getData = async () => {
            setState((currentState) => ({...currentState, isLoading: true}))
            try{
                const data = await api.get("/api/rides/list");
                const last = await api.get("/api/rides/lastrunning");
                const lastRunning = last.Data.ID !== 0
                setState((currentState) => ({...currentState, data: data, lastRunning: lastRunning, isLoading: false}))
            }catch(error){
                setState((currentState) => ({...currentState, isLoading: false, error: error}))
            }
        }
        getData();
    }, []);

    const {isLoading, lastRunning, data, error} = state
    const rows = data ? data["Data"] : [];

    if (isLoading) {
        return ( 
            <Grid
                container
                direction="column"
                justify="center" 
                alignItems="center"
                style={{ minHeight: "100vh" }}
            >
                <Grid item >
                    <Typography variant="h5"> Loading... </Typography>
                </Grid>
                <Grid item >
                    <CircularProgress className={classes.spinner} /> 
                </Grid>
            </Grid>
        )
    }

    return (
        <div className={classes.root}>
            <Typography variant="h5">Car Log List </Typography>
            {error && (<Typography variant="h5"> Error: {error} </Typography>) }

            {lastRunning && (<SpeedDial
                ariaLabel="Stop Ride"
                className={classes.speedDialStop}
                icon={<CheckCircleIcon />}
                onClick={ () => props.history.push("/stopride") }
                direction="up"
                open={false}
            >
            </SpeedDial> ) }

            <List>
                {rows.slice().reverse().map((row) => (
                    <Fragment key={row.ID}>
                        <ListItem button onClick={() => props.history.push(`/edit/${row.ID}`) }>
                            <ListItemText
                                edge="start"
                                secondary={
                                    <React.Fragment>
                                        <Typography
                                            component="span"
                                            variant="body2"
                                            className={classes.inline}
                                            color="textPrimary"
                                        >
                                            {row.From} <br />
                                            {row.To}
                                        </Typography>
                                        {""}
                                    </React.Fragment>
                                }
                            >
                                {convertDate(row.StartTime)}
                            </ListItemText>

                            <span className={classes.km}> {row.OdoEnd-row.OdoStart} km</span>
                        </ListItem>
                        <Divider component="li" />
                    </Fragment>
                ))}
            </List>

            <SpeedDial
                ariaLabel="SpeedDial example"
                className={classes.speedDial}
                icon={<SpeedDialIcon />}
                // onClose={() => setOpen(false)}
                // onOpen={() => setOpen(true)}
                onClick={ () => props.history.push("/addride") }
                open={false}
                direction="up"
            >
            </SpeedDial>

            <SpeedDial
                ariaLabel="Start Ride"
                className={classes.speedDialStart}
                icon={<DirectionsCarIcon />}
                onClick={ () => props.history.push("/startride") }
                direction="up"
                open={false}
            >
            </SpeedDial>

        </div>
    );
};

export default ListItems;
